export default __webpack_public_path__ + "static/media/map.0b722ccb.png";